import { SIGN_IN, SIGN_OUT, RESET_PASSWORD, SET_ENV ,SET_BRANDNAME} from "../actions/types";

const INITIAL_STATE = {
  isAuthenticated: null,
  passwordReset: null,
  passResetErr: null,
  loginErr: null,
  user: {},
  env: {},
  brand:{}
};

export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        user: action.payload.user,
        loginErr: action.payload.error
      };
    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: {}
      };
    case RESET_PASSWORD:
      return {
        ...state,
        passwordReset: action.payload.passwordReset,
        passResetErr: action.payload.error,
      };
    case SET_ENV:
      return {
        ...state,
        env: action.payload        
      };
    case SET_BRANDNAME:
      return {
        ...state,
        brand: action.payload        
      };
    default:
      return state;
  }
}